import type { Bordereau, Mouvement } from '@mairistem/comptabilite';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BaseBordereauState from './BaseBordereauState';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import BordereauActualiseEtatAction from '../actions/BordereauActualiseEtatAction';

class BordereauAttenteTransmissionParapheurState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.ATTENTE_TRANSMISSION_PARAPHEUR;
    this.state = BordereauStateType.ATTENTE_TRANSMISSION_PARAPHEUR;
    this.color = '#000d8c';
    this.libelle = 'Attente transmission parapheur';
  }

  getBordereauActions(_bordereau : Bordereau): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
      new BordereauActualiseEtatAction({ isActionPrincipale: true }),
    ];
  }

  getMouvementActions(): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
    ];
  }
}

export default BordereauAttenteTransmissionParapheurState;
